import { render, staticRenderFns } from "./family-relation-list-group-input.vue?vue&type=template&id=4a5e7f2d&scoped=true&"
import script from "./family-relation-list-group-input.vue?vue&type=script&lang=ts&"
export * from "./family-relation-list-group-input.vue?vue&type=script&lang=ts&"
import style0 from "./family-relation-list-group-input.vue?vue&type=style&index=0&id=4a5e7f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e7f2d",
  null
  
)

export default component.exports